import React from 'react';

import styles from './Products.module.css';
// import {productTypes} from "../../mock/productTypes.ts";
// import {cn} from "../../utils/cn.ts";
import {Product} from "../ProductCard/types/productCard.interface.ts";

interface Props {
    products: Product[]
}

export const Products: React.FC<Props> = ({products}) => {
    return (
        <div className={styles.container}>
            {/*<ul className={cn(styles.list)}>*/}
            {/*    {productTypes.map(({id, name, link}) => (*/}
            {/*        <li key={id} className={styles.item}>*/}
            {/*            <a className={styles.link} href={link}>{name}</a>*/}
            {/*        </li>*/}
            {/*    ))}*/}
            {/*</ul>*/}
            {/*<div className={styles.line}></div>*/}
            <ul className={styles.products}>
                {products.map(({productId, img, name, link}) => {
                    return <li key={productId} className={styles.product}>
                        <a href={link}>
                            <img className={styles.img} src={img} alt={name}/>
                            <div className={styles.title}>
                                {name}
                            </div>
                        </a>
                    </li>
                })}
            </ul>
        </div>
    );
};